import styled from "styled-components";
import {Modal, Space, Card, Typography, Input, Button} from "antd";

const {Title, Text} = Typography;

export const StyledModal = styled(Modal)`
    top: 20px;
`;

export const Container = styled(Space)`
    width: 100%;
`;

export const ContentWrapper = styled.div`
    display: flex;
    gap: 20px;
    height: 800px;
`;

export const PoolsListContainer = styled.div`
    width: 25%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 300px;
`;

export const PoolsListTitle = styled(Title)`
    margin-bottom: 16px;
`;

export const SearchInput = styled(Input.Search)`
    margin-bottom: 16px;
`;

export const PoolsList = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const MapContainer = styled.div`
    width: 75%;
    height: 100%;
    position: relative;
    flex-grow: 1;
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    border-radius: 8px;
`;

export const WarningBadge = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    background: #faad14;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const PoolCard = styled(Card)`
    cursor: pointer;
    background-color: ${props => (props.selected ? "#f0f5ff" : "white")};
    border-radius: 12px;
    margin-right: 8px;
    position: relative;
    overflow: hidden;
    border: 1px solid #e6e6e6;
    transition: all 0.2s ease;
`;

export const PoolCardContent = styled(Space)`
    width: 100%;
    justify-content: space-between;
    padding-left: 8px;
`;

export const PoolInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const PoolColorIndicator = styled.div`
    width: 16px;
    height: 16px;
    background-color: ${props => (props.hasH3Cells ? props.color : "#d9d9d9")};
    border-radius: 4px;
    flex-shrink: 0;
    border: 2px solid white;
    box-shadow: 0 0 0 1px ${props => (props.hasH3Cells ? props.color + "40" : "#d9d9d940")};
`;

export const EditButton = styled(Button)`
    opacity: ${props => (props.visible ? 1 : 0)};
    visibility: ${props => (props.visible ? "visible" : "hidden")};
    transition: all 0.2s ease;
    color: #1890ff;
    padding: 4px;
    height: 24px;
    width: 24px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 32px;
`;

export const ModalTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ErrorMessage = styled.div`
    margin-bottom: 16px;
    color: #ff4d4f;
`;

export const WarningMessage = styled.div`
    margin-bottom: 16px;
    color: #faad14;
`;

export const PoolCardTitle = styled(Title)`    margin: 0px !important;
    font-size: 14px;
    color: ${props => (props.selected ? "#1890ff" : "rgba(0,0,0,0.85)")};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const PoolCardText = styled(Text)`    font-size: 12px;
`;

export const AllPoolsCard = styled(PoolCard)`
    background-color: ${props => (props.selected ? "#f0f5ff" : "white")};
`;

export const AllPoolsTitle = styled(Title)`
    margin: 0px !important;
    color: #1890ff;
    font-size: 14px;
`;

export const AllPoolsText = styled(Text)`
    font-size: 12px;
`;


